import { render, staticRenderFns } from "./ImageWrapper.vue?vue&type=template&id=ca141afa&scoped=true"
import script from "./ImageWrapper.vue?vue&type=script&lang=js"
export * from "./ImageWrapper.vue?vue&type=script&lang=js"
import style0 from "./ImageWrapper.vue?vue&type=style&index=0&id=ca141afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca141afa",
  null
  
)

export default component.exports